import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import {
  AlertController,
  LoadingController,
  ModalController,
} from "@ionic/angular";
import * as saveAs from "file-saver";
import { ApiserviceService } from "../../../httpservice/apiservice.service";
import { AppService } from "../../../services/app.service";
import { ReportSendDocumentComponent } from "../report-send-document/report-send-document.component";
import { CATEGORY } from "../report.constants";
import { FormReport } from "../report.interfaces";
// import * as moment from "moment";
var moment = require("moment"); // require

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { thaiVfsFonts } from "src/app/vfs_thai_fonts";
import { STORAGE } from "src/app/constant/storages";
import { _getStorage } from "src/app/utils/local-storage";
import { errMsg } from "../../../text_control/error-msg";
pdfMake.vfs = { ...pdfFonts.pdfMake.vfs, ...thaiVfsFonts.pdfMake.vfs };

pdfMake.fonts = {
  THSarabunNew: {
    normal: "THSarabunNew.ttf",
    bold: "THSarabunNew-Bold.ttf",
    italics: "THSarabunNew-Italic.ttf",
    bolditalics: "THSarabunNew-BoldItalic.ttf",
  },
  Roboto: {
    normal: "Roboto-Regular.ttf",
    bold: "Roboto-Medium.ttf",
    italics: "Roboto-Italic.ttf",
    bolditalics: "Roboto-MediumItalic.ttf",
  },
};

@Component({
  selector: "app-report-document",
  templateUrl: "./report-document.component.html",
  styleUrls: ["./report-document.component.scss"],
})
export class ReportDocumentComponent implements OnInit {
  checkReportId = CATEGORY;
  reportId: string;
  showfulltax = false;
  showcreditnote = false;
  showcreditnotenotuse = false;
  formReport: FormReport;
  fileName = "ExcelSheetw.xlsx";
  reportData = [];
  token = "";
  // loading = false;
  last_index = 0;
  rowNum = 1;
  widths = 80;
  countApi = 0;
  Company = [
    {
      ContainerNo: "1",
      SelCondition: "1",
      ContainerCondition: "1",
      GateInDateTime: "1",
    },
    {
      ContainerNo: "2",
      SelCondition: "2",
      ContainerCondition: "2",
      GateInDateTime: "2",
    },
    {
      ContainerNo: "3",
      SelCondition: "3",
      ContainerCondition: "3",
      GateInDateTime: "3",
    },
  ];

  length = 10;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 25, 100];

  pages: any = [];
  lastPage: number = 0;
  currPage: number = 0;
  originalReportData: any = [];
  originalReportdataCn: any = [];
  isFirstPage: boolean = true;
  isLastPage: boolean = false;

  scope: String;
  storeid: any;
  storebu: any;
  totalvat: any;
  countpage = 0;
  grouppdfCNS: any;
  totalVat: any;
  // reportdatecn: any;
  dataReport: any;
  loading = true;
  tokenExcel: any = "";

  userID = "";
  userBu = "";
  userLoc = "";
  userRole = "";
  userSource = "";

  formData: any;

  constructor(
    public modalController: ModalController,
    private route: ActivatedRoute,
    private router: Router,
    private apiservice: ApiserviceService,
    private http: HttpClient,
    private appService: AppService,
    public alertController: AlertController,
    public loadingController: LoadingController
  ) {
    this.userID = _getStorage(STORAGE.userID);
    this.userRole = _getStorage(STORAGE.userRole);
    this.userBu = _getStorage(STORAGE.userBu);
    this.userLoc = _getStorage(STORAGE.userLoc);
    this.userSource = _getStorage(STORAGE.SOURCE_SYSTEM);

    this.route.queryParams.subscribe(async (params) => {
      if (Object.keys(params).length !== 0) {
        this.formData = params.formReport;
        const { formReport } = params;
        this.formReport = JSON.parse(formReport);
        this.reportId = this.formReport.category;

        this.scope = this.formReport.scope;
        this.storeid =
          this.formReport.storeid.seller_storeid === "00000"
            ? "all"
            : this.formReport.storeid.seller_storeid;
        this.storebu = this.formReport.storebu;

        await this.callApi(JSON.parse(formReport));
        // await this.exportexcel(this.formReport)
      }
    });
  }

  async ngOnInit() {
    this.loading = true;
  }

  checkstatus(item) {
    // console.log('status....',item);
    if (item.invoice_status === "complete") {
      return "ใช้งาน";
    } else if (item.invoice_status === "cancel") {
      return "ยกเลิก";
    }
  }

  ionViewWillLeave() {
    this.reportData = [];
    this.pagedItems = [];
  }

  async callApiInterval(req, token) {
    const req_cns = {
      ...req,
      token: token,
      dataonTemplate: "TEMPLATEPDF",
    };
    console.log("========= req api interval cns =======", req_cns);
    const loading = await this.loadingController.create({
      message: "Please wait...",
    });
    await loading.present();
    return new Promise((resolve) => {
      const interval = setInterval(async () => {
        const url = `${this.apiservice.apiUrl}${this.apiservice.getCnout}`;
        this.apiservice
          ._post(url, req_cns)
          .then((res) => {
            console.log("========= res api interval cns =======", res);
            if (
              res.statusCode === 200 ||
              res.statusCode === 400 ||
              res.statusCode === 204
            ) {
              loading.dismiss();
              clearInterval(interval);
              resolve(res);
            }
          })
          .catch((error) => {
            console.log("========= res api interval cns error =======", error);
            loading.dismiss();
            clearInterval(interval);
            resolve("");
          });
      }, 10000);
    });
  }

  async callApi(formReport) {
    this.loading = true;

    let res: any;
    let url: any = "";

    if (this.reportId === "003") {
      url = `${this.apiservice.apiUrl}${this.apiservice.reportExport}`;
    } else {
      url = `${this.apiservice.apiUrl}${this.apiservice.inquirySearchList}`;
    }

    const req = {
      page: "",
      tel: "",
      scope: this.scope,
      storebu: this.storebu,
      storeid: this.scope == "self" ? this.userLoc : this.storeid,
      userRole: this.userRole,
      userBu: this.userBu,
      userLoc: this.userLoc,
      userid: this.userID,
      userSource: this.userSource,
      company_name: "",
      buyer_tax_id: "",
      abb_no: "",
      datafor: this.reportId == "003" ? "" : "report",
      receiptdate: "",
      exportType: this.reportId,
      type:
        this.reportId == "001"
          ? "fulltax"
          : this.reportId == "002"
          ? "creditnote"
          : this.reportId == "003"
          ? "creditnotenotuse"
          : "",
      startdate: "",
      enddate: "",
      page_name: "report",
    };
    // formReport.reportdatecn

    let startDatetmp = new Date(formReport.reprotDateStart);
    let endDatetmp = new Date(formReport.reprotDateTo);
    let reportdateCn = new Date(formReport.reportdatecn);

    let tmpDateCN =
      reportdateCn.getFullYear() +
      "-" +
      (reportdateCn.getMonth() + 1) +
      "-" +
      reportdateCn.getDate();

    let tmpStartDate =
      startDatetmp.getFullYear() +
      "-" +
      (startDatetmp.getMonth() + 1) +
      "-" +
      startDatetmp.getDate() +
      " 00:00:00";
    let tmpEndDate =
      endDatetmp.getFullYear() +
      "-" +
      (endDatetmp.getMonth() + 1) +
      "-" +
      endDatetmp.getDate() +
      " 23:59:59";

    console.log("set temp req date : >>> ", tmpStartDate, "][", tmpEndDate);
    req.startdate = tmpStartDate;
    req.enddate = tmpEndDate;
    req.receiptdate = tmpDateCN;
    if (req.type === "fulltax") {
      this.showfulltax = true;
      this.showcreditnote = false;
      this.showcreditnotenotuse = false;
    } else if (req.type === "creditnote") {
      this.showfulltax = false;
      this.showcreditnote = true;
      this.showcreditnotenotuse = false;
    } else if (req.type === "creditnotenotuse") {
      this.showcreditnotenotuse = true;
      this.showfulltax = false;
      this.showcreditnote = false;
    }

    try {
      let res: any;
      console.log("======= req export ============", req);

      if (this.reportId === "003") {
        res = await this.apiservice._post(url, req);
        console.log("======= res export ============", res);
        // res = mokupdata;
        if (res.data.hasOwnProperty("token")) {
          this.tokenExcel = res.data.token;
          res = await this.callApiInterval(req, res.data.token);
        }
      } else {
        res = await this.apiservice._post(url, req);
      }

      console.log("=========res report==========", res);

      if (res.statusCode === 200) {
        this.loading = false;
        this.currPage = 0;
        this.reportData = [];
        this.pagedItems = [];
        this.totalvat = res.data;
        this.originalReportData = res.data.invoice_list;
        // this.originalReportData = MUKUPREPORT.data.invoice_list;

        this.originalReportdataCn = res.data.list;
        this.totalVat = res.data;
        if (req.type === "creditnotenotuse") {
          let groupdata_ticket = [];
          for (const list of this.originalReportdataCn) {
            for (const buData of list.data) {
              let group = buData.ticket.map((locaData) => ({
                ...locaData,
                returndate: res.data.reportheader.returndate,
                bu: list.bu,
                branchName: buData.branchName,
                locCode: buData.locCode,
                name: buData.name,
              }));
              groupdata_ticket.push(...group);
            }
          }
          // for (let i = 0; i < this.originalReportdataCn.length; i++) {
          //   for (let n = 0; n < this.originalReportdataCn[i].data.length; n++) {
          //     // for (
          //     //   let k = 0;
          //     //   k < this.originalReportdataCn[i].data[n].ticket.length;
          //     //   k++
          //     // ) {
          //     let group = this.originalReportdataCn[i].data[n].ticket.map((m) => ({
          //       ...m,
          //       returndate: res.data.reportheader.returndate,
          //       bu: this.originalReportdataCn[i].bu,
          //       branchName: this.originalReportdataCn[i].data[n].branchName,
          //       locCode: this.originalReportdataCn[i].data[n].locCode,
          //       name: this.originalReportdataCn[i].data[n].name,
          //       taxValues: this.originalReportdataCn[i].taxValue,
          //       totalNonVatItemAmts:
          //         this.originalReportdataCn[i].totalNonVatItemAmt,
          //       totalSaleAmts: this.originalReportdataCn[i].totalSaleAmt,
          //       totalVatItemAmts: this.originalReportdataCn[i].totalVatItemAmt,
          //     }));
          //     // }
          //     groupdata_ticket.push(...group);
          //   }
          // }
          console.log(
            "===========groupdata_ticket===============",
            groupdata_ticket
          );
          this.grouppdfCNS = groupdata_ticket;
          this.reportData = groupdata_ticket;
          this.setPage(1);
        } else {
          this.reportData = this.originalReportData;
          this.setPage(1);
        }
        this.currPage += 1;

        this.lastPage = Math.ceil(res.data.count / 10);
        if (this.lastPage <= 1) {
          this.isFirstPage = true;
          this.isLastPage = true;
        } else {
          this.isFirstPage = true;
          this.isLastPage = false;
        }

        this.pages = [];
        for (let p = 0; p < this.lastPage; p++) {
          this.pages.push(p + 1 + "");
        }
      } else if (res.statusCode === 204) {
        this.loading = false;
      } else if (res.statusCode === 400) {
        this.loading = false;
      } else {
        this.loading = false;
      }
    } catch (error) {
      this.loading = false;
    }
  }

  async presentModal() {
    const modal = await this.modalController.create({
      component: ReportSendDocumentComponent,
      cssClass: "my-custom-class",
    });
    modal.onDidDismiss().then(() => {});
    return await modal.present();
  }

  itemView(i) {
    const report_data = [];
    report_data.push({
      bu: this.userBu,
      receiptNumber: i.abb_no,
      newReceiptNumber: i.abb_no,
      originalReceiptNumber: i.abb_no_ref,
      newTaxInvoiceNumber:
        this.reportId == "002" ? i.creditnote_no : i.tax_invoice_no,
      originalTaxInvoiceNumber: i.tax_invoice_no_ref,
      taxpayerIdentificationNumber: i.tax_cid_no,
      taxInvoiceNumber: i.tax_invoice_no,
      branchOrder: i.branch_no,
      address: i.display_address,
      email: i.email,
      detail: {
        category: "category",
        name: "name",
        numberID: "numberID",
        branchOrder: i.branch_no,
      },
    });

    const navigationExtras = {
      queryParams: {
        items: JSON.stringify(i),
        reportId: JSON.stringify(this.reportId),
        formData: this.formData,
      },
    };
    this.router.navigate(["report-detail"], navigationExtras);
  }

  data_name = "";
  async exportexcel() {
    console.log("formReport.......", this.formReport);

    let url = "";

    if (this.reportId === "003") {
      url = `${this.apiservice.apiUrl}${this.apiservice.getCnout}`;
    } else {
      url = `${this.apiservice.apiUrl}${this.apiservice.reportExport}`;
    }

    const report_data = {
      page: "",
      tel: "",
      scope: this.scope,
      storebu: this.storebu,
      storeid: this.storeid,
      userRole: this.userRole,
      userBu: this.userBu,
      userLoc: this.userLoc,
      userid: this.userID,
      userSource: this.userSource,
      company_name: "",
      buyer_tax_id: "",
      abb_no: "",
      datafor: this.reportId == "003" ? "CNOUTEXCEL" : "report",
      receiptdate: "",
      exportType: this.reportId,
      type:
        this.reportId == "001"
          ? "fulltax"
          : this.reportId == "002"
          ? "creditnote"
          : this.reportId == "003"
          ? "creditnotenotuse"
          : "",
      startdate: "",
      enddate: "",
      dataonTemplate: "TEMPLATEEXCEL",
      token: this.tokenExcel,
    };

    let startDatetmp = new Date(this.formReport.reprotDateStart);
    let endDatetmp = new Date(this.formReport.reprotDateTo);
    let reportdateCn = new Date(this.formReport.reportdatecn);

    let tmpDateCN =
      reportdateCn.getFullYear() +
      "-" +
      (reportdateCn.getMonth() + 1) +
      "-" +
      reportdateCn.getDate();

    let tmpStartDate =
      startDatetmp.getFullYear() +
      "-" +
      (startDatetmp.getMonth() + 1) +
      "-" +
      startDatetmp.getDate() +
      " 00:00:00";
    let tmpEndDate =
      endDatetmp.getFullYear() +
      "-" +
      (endDatetmp.getMonth() + 1) +
      "-" +
      endDatetmp.getDate() +
      " 23:59:59";

    console.log("set temp req date : >>> ", tmpStartDate, "][", tmpEndDate);
    report_data.startdate = tmpStartDate;
    report_data.enddate = tmpEndDate;
    report_data.receiptdate = tmpDateCN;
    this.data_name = report_data.type;

    console.log("exportexcel =====>>>>> ", report_data);
    let res: any;
    if (this.reportId === "003") {
      res = await this.apiservice._post(url, report_data);
    } else {
      res = await this.apiservice._post(url, report_data);
    }
    console.log("res report excel------->", res);
    this.saveFile(res.data);
  }

  private formatDateTime(datetime: Date) {
    const fileDateTime =
      ("0" + datetime.getDate()).slice(-2) +
      "-" +
      ("0" + (datetime.getMonth() + 1)).slice(-2) +
      "-" +
      datetime.getFullYear() +
      "-" +
      ("0" + datetime.getHours()).slice(-2) +
      "-" +
      ("0" + datetime.getMinutes()).slice(-2) +
      "-" +
      ("0" + datetime.getSeconds()).slice(-2);
    return fileDateTime;
  }

  private async saveFile(res) {
    // console.log('name....',name);
    let name = "";
    if (this.data_name === "fulltax") {
      name = "REPORT_FTIRP";
    } else if (this.data_name === "creditnote") {
      name = "REPORT_CN";
    } else {
      name = "REPORT_CN_OUT";
    }
    const ab = new ArrayBuffer(res.data.length);
    const view = new Uint8Array(ab);
    for (let i = 0; i < res.data.length; i++) {
      view[i] = res.data[i];
    }
    const datetime = new Date();
    const fileDateTime = this.formatDateTime(datetime);
    const fileName = `${name}_${fileDateTime}.xlsx`;
    const file = new Blob([ab], { type: "application/octet-stream" });
    return saveAs.saveAs(file, fileName);
  }

  pager: any = {};
  pagedItems = [];
  count: any;

  colors: any = "primary";

  setPage(page: number) {
    // get pager object from service
    console.log();
    this.pager = this.appService.getPager(this.reportData.length, page);
    this.rowNum = this.pager.totalItems;

    console.log("======= this.pager ========", this.pager);

    // get current page of items
    this.pagedItems = this.reportData.slice(
      this.pager.startIndex,
      this.pager.endIndex + 1
    );
    console.log("======= this.reportData ========", this.reportData);
  }

  async currentPage(page: any) {
    this.countpage = page - 1;

    this.currPage = parseInt(page);
    await this.getResendData(page, "N");
  }

  async getResendData(page: any, isNext: string) {
    this.reportData = [];

    if (isNext == "Y") {
      this.pages.push(page);
    }

    if (this.lastPage <= 1) {
      this.isFirstPage = true;
      this.isLastPage = true;
    } else if (this.currPage === 1) {
      this.isFirstPage = true;
      this.isLastPage = false;
    } else if (this.currPage >= this.lastPage) {
      this.isLastPage = true;
      this.isFirstPage = false;
    } else if (this.lastPage > 1) {
      this.isLastPage = false;
      this.isFirstPage = false;
    } else {
      this.isLastPage = false;
    }

    let s_point = this.currPage * 10 - 10;
    this.reportData = [];

    if (this.reportId === "003") {
      for (let i = s_point; i < this.originalReportdataCn.length; i++) {
        if (i < s_point + 10) {
          this.reportData.push(this.originalReportdataCn[i]);
        }
      }
    } else {
      for (let i = s_point; i < this.originalReportData.length; i++) {
        if (i < s_point + 10) {
          this.reportData.push(this.originalReportData[i]);
        }
      }
    }
  }

  checkbranch(data: any) {
    if (data.Mbranch_no === "สำนักงานใหญ่") {
      return "สำนักงานใหญ่";
    } else if (data.branch_no !== "") {
      return data.branch_no;
    } else {
      return "-";
    }
  }
  formatnumber(data) {
    return Number(data)
      .toFixed(2)
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }

  checkabb(data: any) {
    let branch_no = data.split("-");
    let numberBranch = branch_no[0] + "-" + branch_no[1].padStart(6, "0");
    return numberBranch;
  }

  async ErrorMsg(message: string) {
    let alert = await this.alertController.create({
      cssClass: "my-custom-class",
      message: message,
      buttons: [
        {
          text: "OK",
          cssClass: "alertButton",
        },
      ],
    });
    await alert.present();
  }

  datapdf: any;

  async exportpdfFulltax() {
    let ListOfBU: any;

    const url = `${this.apiservice.apiUrl}${this.apiservice.reportExport}`;

    const report_data = {
      page: "",
      tel: "",
      scope: this.scope,
      storebu: this.storebu,
      storeid: this.storeid,
      userRole: this.userRole,
      userBu: this.userBu,
      userLoc: this.userLoc,
      userid: this.userID,
      userSource: this.userSource,
      company_name: "",
      buyer_tax_id: "",
      abb_no: "",
      datafor: this.reportId == "003" ? "CNOUTEXCEL" : "report",
      receiptdate: "",
      exportType: this.reportId,
      type:
        this.reportId == "001"
          ? "fulltax"
          : this.reportId == "002"
          ? "creditnote"
          : this.reportId == "003"
          ? "creditnotenotuse"
          : "",
      startdate: "",
      dataonTemplate: "TEMPLATEPDF",
      enddate: "",
    };

    let startDatetmp = new Date(this.formReport.reprotDateStart);
    let endDatetmp = new Date(this.formReport.reprotDateTo);
    let reportdateCn = new Date(this.formReport.reportdatecn);

    let tmpDateCN =
      reportdateCn.getFullYear() +
      "-" +
      (reportdateCn.getMonth() + 1) +
      "-" +
      reportdateCn.getDate();

    let tmpStartDate =
      startDatetmp.getFullYear() +
      "-" +
      (startDatetmp.getMonth() + 1) +
      "-" +
      startDatetmp.getDate() +
      " 00:00:00";
    let tmpEndDate =
      endDatetmp.getFullYear() +
      "-" +
      (endDatetmp.getMonth() + 1) +
      "-" +
      endDatetmp.getDate() +
      " 23:59:59";

    console.log("set temp req date : >>> ", tmpStartDate, "][", tmpEndDate);
    report_data.startdate = tmpStartDate;
    report_data.enddate = tmpEndDate;
    report_data.receiptdate = tmpDateCN;

    this.data_name = report_data.type;
    let res;
    try {
      res = await this.apiservice._post(url, report_data);
      console.log("=========res data export ===========", res);

      if (res.statusCode === 200) {
        ListOfBU = res.data.list;
      } else {
        this.ErrorMsg(res.statusMessage);
      }
    } catch (error) {
      this.ErrorMsg(errMsg.error);
    }

    const d = moment().format("YYYY-MM-DD");
    let arr = d.split("-");
    this.datapdf =
      arr[2].substring(0, 10) + "/" + arr[1].substring(0, 10) + "/" + arr[0];
    let dataAddr = res.data.reportheader;
    console.log("[exportpdfFulltax] dataAddr : ", dataAddr);
    let databody = [];
    let last_index = 0;

    console.log("======= ListOfBU ==========", ListOfBU);

    for (let i = 0; i < ListOfBU.length; i++) {
      let ticket = ListOfBU[i].ticket;

      for (let line of ticket) {
        last_index += 1;
        databody.push([
          {
            text: last_index,
            alignment: "center",
            fontSize: 10,
          },
          // {
          //   text: ListOfBU[i].bu,
          //   alignment: "center",
          //   fontSize: 10,
          // },
          {
            text: line.seller_branch_name,
            alignment: "center",
            fontSize: 10,
          },
          {
            text: line.created_time,
            alignment: "center",
            fontSize: 10,
          },
          {
            text: line.tax_invoice_no,
            alignment: "center",
            fontSize: 10,
          },
          {
            text: line.rcpt_date,
            alignment: "center",
            fontSize: 10,
          },
          {
            text: line.abb_no,
            alignment: "center",
            fontSize: 10,
          },
          {
            text: line?.tax_invoice_no_ref || "-",
            alignment: "center",
            fontSize: 10,
          },
          {
            text: line?.created_time_ref || "-",
            alignment: "center",
            fontSize: 10,
          },
          {
            text: line.buyer_company_name,
            alignment: "center",
            fontSize: 10,
          },
          {
            text: line.tax_cid_no,
            alignment: "center",
            fontSize: 10,
          },
          {
            text: line?.branch_no || "-",
            alignment: "center",
            fontSize: 10,
          },
          // {
          //   text: line.Mbranch_no,
          //   alignment: "center",
          //   fontSize: 10,
          // },
          // {
          //   text: line.branch_no,
          //   alignment: "center",
          //   fontSize: 10,
          // },
          {
            text: line.totalSaleAmt.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"),
            alignment: "right",
            fontSize: 10,
          },
          {
            text: line.totalNonVatItemAmt.replace(
              /(\d)(?=(\d{3})+(?!\d))/g,
              "$1,"
            ),
            alignment: "right",
            fontSize: 10,
          },
          {
            text: line.totalVatSaleAmt.replace(
              /(\d)(?=(\d{3})+(?!\d))/g,
              "$1,"
            ),
            alignment: "right",
            fontSize: 10,
          },
          {
            text: line.taxValue.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"),
            alignment: "right",
            fontSize: 10,
          },
          {
            text: line.invoice_status,
            alignment: "center",
            fontSize: 10,
          },
        ]);
      }
      // end invoice list of buXX
      databody.push([
        {
          text: `ยอดรวมทั้งหมด (${ListOfBU[i].branchName})`,
          colSpan: 11,
          alignment: "right",
          bold: true,
          fillColor: "#e0e0e0",
        },
        // "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        {
          text: ListOfBU[i].loc_totalSaleAmt.replace(
            /(\d)(?=(\d{3})+(?!\d))/g,
            "$1,"
          ),
          bold: true,
          alignment: "right",
          fontSize: 10,
          noWrap: true,
          fillColor: "#e0e0e0",
        },
        {
          text: ListOfBU[i].loc_totalNonVatItemAmt.replace(
            /(\d)(?=(\d{3})+(?!\d))/g,
            "$1,"
          ),
          bold: true,
          alignment: "right",
          fontSize: 10,
          noWrap: true,
          fillColor: "#e0e0e0",
        },
        {
          text: ListOfBU[i].loc_totalVatSaleAmt.replace(
            /(\d)(?=(\d{3})+(?!\d))/g,
            "$1,"
          ),
          bold: true,
          alignment: "right",
          fontSize: 10,
          noWrap: true,
          fillColor: "#e0e0e0",
        },
        {
          text: ListOfBU[i].loc_taxValue.replace(
            /(\d)(?=(\d{3})+(?!\d))/g,
            "$1,"
          ),
          bold: true,
          noWrap: true,
          alignment: "right",
          fontSize: 10,
          fillColor: "#e0e0e0",
        },
        {
          text: "",
          fillColor: "#e0e0e0",
          // pageBreak: 'before'
        },
      ]);
    }
    // pdfmake.content[pdfmake.content.length - 1]["pageBreak"] = "";

    databody.push([
      {
        text: "ยอดรวมทั้งหมด",
        colSpan: 11,
        alignment: "right",
        bold: true,
        fillColor: "#e0e0e0",
      },
      // "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      {
        text: res.data.All_totalSaleAmt.replace(
          /(\d)(?=(\d{3})+(?!\d))/g,
          "$1,"
        ),
        bold: true,
        alignment: "right",
        fontSize: 10,
        noWrap: true,
        fillColor: "#e0e0e0",
      },
      {
        text: res.data.All_totalNonVatItemAmt.replace(
          /(\d)(?=(\d{3})+(?!\d))/g,
          "$1,"
        ),
        bold: true,
        alignment: "right",
        fontSize: 10,
        noWrap: true,
        fillColor: "#e0e0e0",
      },
      {
        text: res.data.All_totalVatSaleAmt.replace(
          /(\d)(?=(\d{3})+(?!\d))/g,
          "$1,"
        ),
        bold: true,
        alignment: "right",
        fontSize: 10,
        noWrap: true,
        fillColor: "#e0e0e0",
      },
      {
        text: res.data.All_taxValue.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"),
        bold: true,
        noWrap: true,
        alignment: "right",
        fontSize: 10,
        fillColor: "#e0e0e0",
      },
      {
        text: "",
        fillColor: "#e0e0e0",
      },
    ]);

    let pdfmake = {
      compress: false,
      pageSize: "A4",
      pageOrientation: "landscape",
      pageMargins: [12, 15, 12, 15],
      defaultStyle: {
        font: "THSarabunNew",
      },
      content: [],
    };

    let tel: any;
    let seller_tel: any;
    if (dataAddr.seller_tel !== "") {
      seller_tel = dataAddr.seller_tel
        .substring(1, dataAddr.seller_tel.length)
        .split("+")
        .join(",");
    } else {
      seller_tel = "";
    }

    const content = [
      {
        style: "tableExample",
        table: {
          dontBreakRows: true,
          headerRows: 3,
          widths: [
            20, 45, 40, 65, 40, 40, 50, 40, 60, 55, 40, 45, 35, 48, 35, 27,
            // 20, 20, 50, 40, 40, 40, 50, 40, 70, 55, 45, 30, 45, 35, 35, 35, 30,
          ],
          body: [
            [
              {
                colSpan: 16,
                border: [false, false, false, false],
                columns: [
                  {
                    width: 180,
                    text: "",
                  },
                  [
                    {
                      text: `${
                        dataAddr.seller_name +
                        " " +
                        `สาขา${
                          dataAddr.seller_branch == "00000"
                            ? "สำนักงานใหญ่"
                            : dataAddr.seller_branch_name
                        }` +
                        " สาขาที่ " +
                        " " +
                        dataAddr.seller_branch
                      }`,

                      alignment: "center",
                      fontSize: 14,
                    },
                    {
                      text: dataAddr.seller_addrdisplay,
                      width: 500,
                      alignment: "center",
                      fontSize: 14,
                    },
                    {
                      text: `โทร. ${seller_tel}  โทรสาร. ${
                        dataAddr.seller_fax === "" ? "-" : dataAddr.seller_fax
                      }`,
                      alignment: "center",
                      fontSize: 14,
                    },
                    {
                      text: `เลขที่ประจำตัวผู้เสียภาษี ${dataAddr.seller_taxid}`,
                      alignment: "center",
                      fontSize: 14,
                    },
                    {
                      text: "รายงานใบกำกับภาษีเต็มรูปออกจากเครื่อง ออกแทนใบกำกับภาษีอย่างย่อ",
                      alignment: "center",
                      fontSize: 14,
                      bold: true,
                    },
                    {
                      text: `วันที่ ${
                        dataAddr.report_startdate +
                        " - " +
                        dataAddr.report_enddate
                      }`,
                      alignment: "center",
                      fontSize: 14,
                      bold: false,
                    },
                  ],
                  {
                    width: 180,
                    columns: [
                      [
                        {
                          text: `${
                            "StoreID : " +
                            this.userLoc +
                            " " +
                            dataAddr.seller_name
                          }`,
                          alignment: "right",
                          fontSize: 13,
                          bold: true,
                        },
                        {
                          text: `${"User Login : " + this.userID}`,
                          alignment: "right",
                          fontSize: 12,
                          bold: true,
                        },
                        {
                          text: `${"พิมพ์ : " + this.datapdf}`,
                          alignment: "right",
                          fontSize: 12,
                          bold: true,
                        },
                      ],
                    ],
                  },
                ],
              },

              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              // "",
              // "",
            ],
            [
              {
                text: "ลำดับ",
                alignment: "center",
                fontSize: 10,
                rowSpan: 2,
                fillColor: "#e0e0e0",
                style: "tableHeader",
                bold: true,
              },
              // {
              //   text: "BU",
              //   alignment: "center",
              //   fontSize: 10,
              //   rowSpan: 2,
              //   fillColor: "#e0e0e0",
              //   style: "tableHeader",
              //   bold: true,
              // },
              {
                text: "สาขาที่ออก\nใบกำกับภาษี",
                alignment: "center",
                fontSize: 10,
                rowSpan: 2,
                fillColor: "#e0e0e0",
                style: "tableHeader",
                bold: true,
              },
              {
                text: "วันที่ออก\nใบกำกับภาษี",
                alignment: "center",
                fontSize: 10,
                rowSpan: 2,
                fillColor: "#e0e0e0",
                style: "tableHeader",
                bold: true,
              },
              {
                text: "เลขที่\nใบกำกับภาษี",
                alignment: "center",
                fontSize: 10,
                rowSpan: 2,
                fillColor: "#e0e0e0",
                style: "tableHeader",
                bold: true,
              },
              {
                text: "วันที่ออก\nใบกำกับภาษี\nอย่างย่อ",
                alignment: "center",
                fontSize: 10,
                rowSpan: 2,
                fillColor: "#e0e0e0",
                style: "tableHeader",
                bold: true,
              },
              {
                text: "ใบกำกับภาษี\nอย่างย่อเลขที",
                alignment: "center",
                fontSize: 10,
                rowSpan: 2,
                fillColor: "#e0e0e0",
                style: "tableHeader",
                bold: true,
              },
              {
                text: "อ้างอิงเลขที่ใบ\nกำกับภาษีเต็มรูป",
                alignment: "center",
                fontSize: 10,
                rowSpan: 2,
                fillColor: "#e0e0e0",
                style: "tableHeader",
                bold: true,
              },
              {
                text: "วันที่เอกสาร\nอ้างอิง",
                alignment: "center",
                fontSize: 10,
                rowSpan: 2,
                fillColor: "#e0e0e0",
                style: "tableHeader",
                bold: true,
              },
              {
                text: "ชื่อผู้ซื้อ",
                alignment: "center",
                fontSize: 10,
                rowSpan: 2,
                fillColor: "#e0e0e0",
                style: "tableHeader",
                bold: true,
              },
              {
                text: "เลขประจำตัวผู้\nเสียภาษีอากร",
                alignment: "center",
                fontSize: 10,
                rowSpan: 2,
                fillColor: "#e0e0e0",
                style: "tableHeader",
                bold: true,
              },
              {
                text: "สถานประกอบการ",
                alignment: "center",
                fontSize: 10,
                rowSpan: 2,
                fillColor: "#e0e0e0",
                style: "tableHeader",
                bold: true,
              },
              // {},
              {
                text: "จำนวนเงินรวม",
                alignment: "center",
                fontSize: 10,
                rowSpan: 2,
                fillColor: "#e0e0e0",
                style: "tableHeader",
                bold: true,
              },
              {
                text: "มูลค่าสินค้า \nNON VAT",
                alignment: "center",
                fontSize: 10,
                rowSpan: 2,
                fillColor: "#e0e0e0",
                style: "tableHeader",
                bold: true,
              },
              {
                text: "มูลค่าสินค้า VAT",
                alignment: "center",
                fontSize: 10,
                rowSpan: 2,
                fillColor: "#e0e0e0",
                style: "tableHeader",
                bold: true,
              },
              {
                text: "ภาษี\nมูลค่าเพิ่ม",
                alignment: "center",
                fontSize: 10,
                rowSpan: 2,
                fillColor: "#e0e0e0",
                style: "tableHeader",
                bold: true,
              },
              {
                text: "หมายเหตุ",
                alignment: "center",
                fontSize: 10,
                rowSpan: 2,
                fillColor: "#e0e0e0",
                style: "tableHeader",
                bold: true,
              },
            ],
            [
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              // {
              //   text: "สำนักงานใหญ่",
              //   alignment: "center",
              //   fontSize: 10,
              //   fillColor: "#e0e0e0",
              //   style: "tableHeader",
              //   bold: true,
              // },
              // {
              //   text: "สาขาที่",
              //   alignment: "center",
              //   fontSize: 10,
              //   fillColor: "#e0e0e0",
              //   style: "tableHeader",
              //   bold: true,
              // },
              "",
              "",
              "",
              "",
              "",
            ],
            //data table
            ...databody,
          ],
        },
        layout: {
          hLineWidth: function (i, node) {
            return i === 0 || i === node.table.body.length ? 0.2 : 0.1;
          },
          vLineWidth: function (i, node) {
            return i === 0 || i === node.table.widths.length ? 0.2 : 0.1;
          },
          hLineColor: function (i, node) {
            return i === 0 || i === node.table.body.length
              ? "#424242"
              : "#424242";
          },
          vLineColor: function (i, node) {
            return i === 0 || i === node.table.widths.length
              ? "#424242"
              : "#424242";
          },
        },

        pageBreak: "after",
      },
    ];
    pdfmake.content.push(...content);
    try {
      pdfmake.content[pdfmake.content.length - 1]["pageBreak"] = "";
    } catch (error) {}

    const file_name = `${"REPORT_FTIRP_" + this.datapdf}`;
    this.downloadPdf(pdfmake, file_name);
  }

  async exportpdfCN() {
    let ListOfBU: any;
    const url = `${this.apiservice.apiUrl}${this.apiservice.reportExport}`;

    const report_data = {
      page: "",
      tel: "",
      scope: this.scope,
      storeid: this.storeid,
      storebu: this.storebu,
      userRole: this.userRole,
      userBu: this.userBu,
      userLoc: this.userLoc,
      userid: this.userID,
      userSource: this.userSource,
      company_name: "",
      buyer_tax_id: "",
      abb_no: "",
      datafor: this.reportId == "003" ? "CNOUTEXCEL" : "report",
      receiptdate: "",
      exportType: this.reportId,
      type:
        this.reportId == "001"
          ? "fulltax"
          : this.reportId == "002"
          ? "creditnote"
          : this.reportId == "003"
          ? "creditnotenotuse"
          : "",
      startdate: "",
      dataonTemplate: "TEMPLATEPDF",
      enddate: "",
    };

    let startDatetmp = new Date(this.formReport.reprotDateStart);
    let endDatetmp = new Date(this.formReport.reprotDateTo);
    let reportdateCn = new Date(this.formReport.reportdatecn);

    let tmpDateCN =
      reportdateCn.getFullYear() +
      "-" +
      (reportdateCn.getMonth() + 1) +
      "-" +
      reportdateCn.getDate();

    let tmpStartDate =
      startDatetmp.getFullYear() +
      "-" +
      (startDatetmp.getMonth() + 1) +
      "-" +
      startDatetmp.getDate() +
      " 00:00:00";
    let tmpEndDate =
      endDatetmp.getFullYear() +
      "-" +
      (endDatetmp.getMonth() + 1) +
      "-" +
      endDatetmp.getDate() +
      " 23:59:59";

    console.log("set temp req date : >>> ", tmpStartDate, "][", tmpEndDate);
    report_data.startdate = tmpStartDate;
    report_data.enddate = tmpEndDate;
    report_data.receiptdate = tmpDateCN;

    this.data_name = report_data.type;

    let res;
    try {
      res = await this.apiservice._post(url, report_data);
      console.log("=========res data export ===========", res);

      if (res.statusCode === 200) {
        ListOfBU = res.data.list;
      } else {
        this.ErrorMsg(res.statusMessage);
        return;
      }
    } catch (error) {
      this.ErrorMsg(errMsg.error);
      return;
    }

    const d = moment().format("YYYY-MM-DD");
    let arr = d.split("-");
    this.datapdf =
      arr[2].substring(0, 10) + "/" + arr[1].substring(0, 10) + "/" + arr[0];
    let dataAddr = res.data.reportheader;
    console.log("[exportpdfFulltax] dataAddr : ", dataAddr);
    let databody = [];
    let last_index = 0;

    for (let i = 0; i < ListOfBU.length; i++) {
      let ticket = ListOfBU[i].ticket;
      for (let line of ticket) {
        last_index += 1;
        databody.push([
          {
            text: last_index,
            alignment: "center",
            fontSize: 11,
          },
          // {
          //   text: ListOfBU[i].bu,
          //   alignment: "center",
          //   fontSize: 11,
          // },
          {
            text: line.seller_branch_name,
            alignment: "center",
            fontSize: 11,
          },
          {
            text: line.created_time,
            alignment: "center",
            fontSize: 11,
          },
          {
            text: line.creditnote_no,
            alignment: "center",
            fontSize: 11,
          },
          {
            text: line.abb_no,
            alignment: "center",
            fontSize: 11,
          },
          {
            text: line.tax_invoice_no_ref,
            alignment: "center",
            fontSize: 11,
          },
          {
            text: line.created_time_ref,
            alignment: "center",
            fontSize: 11,
          },
          {
            text: line.buyer_company_name,
            alignment: "center",
            fontSize: 11,
          },
          {
            text: line.tax_cid_no,
            alignment: "center",
            fontSize: 11,
          },
          // {
          //   text: line.Mbranch_no,
          //   alignment: "center",
          //   fontSize: 11,
          // },
          {
            text: line?.branch_no || "-",
            alignment: "center",
            fontSize: 11,
          },
          {
            text: line.totalSaleAmt.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"),
            alignment: "right",
            fontSize: 11,
          },
          {
            text: line.totalNonVatItemAmt.replace(
              /(\d)(?=(\d{3})+(?!\d))/g,
              "$1,"
            ),
            alignment: "right",
            fontSize: 11,
          },
          {
            text: line.totalVatSaleAmt.replace(
              /(\d)(?=(\d{3})+(?!\d))/g,
              "$1,"
            ),
            alignment: "right",
            fontSize: 11,
          },
          {
            text: line.taxValue.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"),
            alignment: "right",
            fontSize: 11,
          },
          {
            text: line.cn_reason,
            alignment: "center",
            fontSize: 11,
          },
        ]);
      }
      // end invoice list of buXX
      databody.push([
        {
          text: `ยอดรวมทั้งหมด (${ListOfBU[i].branchName})`,
          colSpan: 10,
          alignment: "right",
          bold: true,
          fillColor: "#e0e0e0",
        },
        // "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        {
          text: ListOfBU[i].loc_totalSaleAmt.replace(
            /(\d)(?=(\d{3})+(?!\d))/g,
            "$1,"
          ),
          bold: true,
          alignment: "right",
          fontSize: 11,
          noWrap: true,
          fillColor: "#e0e0e0",
        },
        {
          text: ListOfBU[i].loc_totalNonVatItemAmt.replace(
            /(\d)(?=(\d{3})+(?!\d))/g,
            "$1,"
          ),
          bold: true,
          alignment: "right",
          fontSize: 11,
          noWrap: true,
          fillColor: "#e0e0e0",
        },
        {
          text: ListOfBU[i].loc_totalVatSaleAmt.replace(
            /(\d)(?=(\d{3})+(?!\d))/g,
            "$1,"
          ),
          bold: true,
          alignment: "right",
          fontSize: 11,
          noWrap: true,
          fillColor: "#e0e0e0",
        },
        {
          text: ListOfBU[i].loc_taxValue.replace(
            /(\d)(?=(\d{3})+(?!\d))/g,
            "$1,"
          ),
          bold: true,
          noWrap: true,
          alignment: "right",
          fontSize: 11,
          fillColor: "#e0e0e0",
        },
        {
          text: "",
          fillColor: "#e0e0e0",
          // pageBreak: 'before'
        },
      ]);
    }
    // pdfmake.content[pdfmake.content.length - 1]["pageBreak"] = "";

    databody.push([
      {
        text: "ยอดรวมทั้งหมด",
        colSpan: 10,
        alignment: "right",
        bold: true,
        fillColor: "#e0e0e0",
      },
      // "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      // "",
      {
        text: res.data.All_totalSaleAmt.replace(
          /(\d)(?=(\d{3})+(?!\d))/g,
          "$1,"
        ),
        bold: true,
        alignment: "right",
        fontSize: 11,
        noWrap: true,
        fillColor: "#e0e0e0",
      },
      {
        text: res.data.All_totalNonVatItemAmt.replace(
          /(\d)(?=(\d{3})+(?!\d))/g,
          "$1,"
        ),
        bold: true,
        alignment: "right",
        fontSize: 11,
        noWrap: true,
        fillColor: "#e0e0e0",
      },
      {
        text: res.data.All_totalVatSaleAmt.replace(
          /(\d)(?=(\d{3})+(?!\d))/g,
          "$1,"
        ),
        bold: true,
        alignment: "right",
        fontSize: 11,
        noWrap: true,
        fillColor: "#e0e0e0",
      },
      {
        text: res.data.All_taxValue.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"),
        bold: true,
        noWrap: true,
        alignment: "right",
        fontSize: 11,
        fillColor: "#e0e0e0",
      },
      {
        text: "",
        fillColor: "#e0e0e0",
      },
    ]);

    let pdfmake = {
      compress: false,
      pageSize: "A4",
      pageOrientation: "landscape",
      pageMargins: [12, 15, 12, 15],
      defaultStyle: {
        font: "THSarabunNew",
      },
      content: [],
    };

    let tel: any;
    let seller_tel: any;
    if (dataAddr.seller_tel !== "") {
      seller_tel = dataAddr.seller_tel
        .substring(1, dataAddr.seller_tel.length)
        .split("+")
        .join(",");
    } else {
      seller_tel = "";
    }

    const content = [
      {
        style: "tableExample",
        table: {
          dontBreakRows: true,
          headerRows: 3,
          widths: [20, 40, 40, 50, 40, 50, 40, 75, 55, 70, 45, 35, 50, 40, 40],
          body: [
            [
              {
                colSpan: 15,
                border: [false, false, false, false],
                columns: [
                  {
                    width: 180,
                    text: "",
                  },
                  [
                    {
                      text: `${
                        dataAddr.seller_name +
                        " " +
                        `สาขา${
                          dataAddr.seller_branch == "00000"
                            ? "สำนักงานใหญ่"
                            : dataAddr.seller_branch_name
                        }` +
                        " สาขาที่ " +
                        " " +
                        dataAddr.seller_branch
                      }`,

                      alignment: "center",
                      fontSize: 14,
                    },
                    {
                      text: dataAddr.seller_addrdisplay,
                      width: 500,
                      alignment: "center",
                      fontSize: 14,
                    },
                    {
                      text: `โทร. ${seller_tel}  โทรสาร. ${
                        dataAddr.seller_fax === "" ? "-" : dataAddr.seller_fax
                      }`,
                      alignment: "center",
                      fontSize: 14,
                    },
                    {
                      text: `เลขที่ประจำตัวผู้เสียภาษี ${dataAddr.seller_taxid}`,
                      alignment: "center",
                      fontSize: 14,
                    },
                    {
                      text: "รายงานภาษีขายลดหนี้",
                      alignment: "center",
                      fontSize: 14,
                      bold: true,
                    },
                    {
                      text: `วันที่ ${
                        dataAddr.report_startdate +
                        " - " +
                        dataAddr.report_enddate
                      }`,
                      alignment: "center",
                      fontSize: 14,
                      bold: false,
                    },
                  ],
                  {
                    width: 180,
                    columns: [
                      [
                        {
                          text: `${
                            "StoreID : " +
                            this.userLoc +
                            " " +
                            dataAddr.seller_name
                          }`,
                          alignment: "right",
                          fontSize: 13,
                          bold: true,
                        },
                        {
                          text: `${"User Login : " + this.userID}`,
                          alignment: "right",
                          fontSize: 12,
                          bold: true,
                        },
                        {
                          text: `${"พิมพ์ : " + this.datapdf}`,
                          alignment: "right",
                          fontSize: 12,
                          bold: true,
                        },
                      ],
                    ],
                  },
                ],
              },

              // "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              // "",
            ],
            [
              {
                text: "ลำดับ",
                alignment: "center",
                fontSize: 10,
                rowSpan: 2,
                fillColor: "#e0e0e0",
                style: "tableHeader",
                bold: true,
              },
              // {
              //   text: "BU",
              //   alignment: "center",
              //   fontSize: 10,
              //   rowSpan: 2,
              //   fillColor: "#e0e0e0",
              //   style: "tableHeader",
              //   bold: true,
              // },
              {
                text: "สาขาที่ออก\nใบกำกับภาษี",
                alignment: "center",
                fontSize: 10,
                rowSpan: 2,
                fillColor: "#e0e0e0",
                style: "tableHeader",
                bold: true,
              },
              {
                text: "วันที่ออก\nใบลดหนี้",
                alignment: "center",
                fontSize: 10,
                rowSpan: 2,
                fillColor: "#e0e0e0",
                style: "tableHeader",
                bold: true,
              },
              {
                text: "เลขที่\nใบลดหนี้",
                alignment: "center",
                fontSize: 10,
                rowSpan: 2,
                fillColor: "#e0e0e0",
                style: "tableHeader",
                bold: true,
              },
              {
                text: "Return Receipt No",
                alignment: "center",
                fontSize: 10,
                rowSpan: 2,
                fillColor: "#e0e0e0",
                style: "tableHeader",
                bold: true,
              },
              {
                text: "อ้างอิงใบกำกับ\nภาษีเต็มรูปเดิม/ใบลดหนี้",
                alignment: "center",
                fontSize: 10,
                rowSpan: 2,
                fillColor: "#e0e0e0",
                style: "tableHeader",
                bold: true,
              },
              {
                text: "วันที่เอกสาร\nอ้างอิง",
                alignment: "center",
                fontSize: 10,
                rowSpan: 2,
                fillColor: "#e0e0e0",
                style: "tableHeader",
                bold: true,
              },
              {
                text: "ชื่อผู้ซื้อ",
                alignment: "center",
                fontSize: 10,
                rowSpan: 2,
                fillColor: "#e0e0e0",
                style: "tableHeader",
                bold: true,
              },
              {
                text: "เลขประจำตัวผู้\nเสียภาษีอากร",
                alignment: "center",
                fontSize: 10,
                rowSpan: 2,
                fillColor: "#e0e0e0",
                style: "tableHeader",
                bold: true,
              },
              {
                text: "สถานประกอบการ",
                alignment: "center",
                fontSize: 10,
                rowSpan: 2,
                fillColor: "#e0e0e0",
                style: "tableHeader",
                bold: true,
              },
              {
                text: "จำนวนเงินรวม",
                alignment: "center",
                fontSize: 10,
                rowSpan: 2,
                fillColor: "#e0e0e0",
                style: "tableHeader",
                bold: true,
              },
              {
                text: "มูลค่าสินค้า \nNON VAT",
                alignment: "center",
                fontSize: 10,
                rowSpan: 2,
                fillColor: "#e0e0e0",
                style: "tableHeader",
                bold: true,
              },
              {
                text: "มูลค่าสินค้า VAT",
                alignment: "center",
                fontSize: 10,
                rowSpan: 2,
                fillColor: "#e0e0e0",
                style: "tableHeader",
                bold: true,
              },
              {
                text: "ภาษี\nมูลค่าเพิ่ม",
                alignment: "center",
                fontSize: 10,
                rowSpan: 2,
                fillColor: "#e0e0e0",
                style: "tableHeader",
                bold: true,
              },
              {
                text: "หมายเหตุ",
                alignment: "center",
                fontSize: 10,
                rowSpan: 2,
                fillColor: "#e0e0e0",
                style: "tableHeader",
                bold: true,
              },
            ],
            [
              // "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              // {
              //   text: "สำนักงานใหญ่",
              //   alignment: "center",
              //   fontSize: 10,
              //   fillColor: "#e0e0e0",
              //   style: "tableHeader",
              //   bold: true,
              // },
              // {
              //   text: "สาขาที่",
              //   alignment: "center",
              //   fontSize: 10,
              //   fillColor: "#e0e0e0",
              //   style: "tableHeader",
              //   bold: true,
              // },
              "",
              "",
              "",
              "",
              "",
              // "",
            ],
            //data table
            ...databody,
          ],
        },
        layout: {
          hLineWidth: function (i, node) {
            return i === 0 || i === node.table.body.length ? 0.2 : 0.1;
          },
          vLineWidth: function (i, node) {
            return i === 0 || i === node.table.widths.length ? 0.2 : 0.1;
          },
          hLineColor: function (i, node) {
            return i === 0 || i === node.table.body.length
              ? "#424242"
              : "#424242";
          },
          vLineColor: function (i, node) {
            return i === 0 || i === node.table.widths.length
              ? "#424242"
              : "#424242";
          },
        },

        pageBreak: "after",
      },
    ];
    pdfmake.content.push(...content);
    try {
      pdfmake.content[pdfmake.content.length - 1]["pageBreak"] = "";
    } catch (error) {}

    const file_name = `${"REPORT_CN_" + this.datapdf}`;
    this.downloadPdf(pdfmake, file_name);
  }

  async exportpdfCNS() {
    const d = moment().format("YYYY-MM-DD");
    let arr = d.split("-");
    this.datapdf =
      arr[2].substring(0, 10) + "/" + arr[1].substring(0, 10) + "/" + arr[0];
    let pdfmake = {
      compress: false,
      pageSize: "A4",
      pageOrientation: "landscape",
      pageMargins: [30, 30, 30, 30],
      defaultStyle: {
        font: "THSarabunNew",
      },
      content: [],
    };

    let databody = [];
    let dataAddr = this.totalvat.reportheader;
    let reportData = this.grouppdfCNS;
    let datafooter = [];
    let last_index = 0;

    console.log(
      "============== originalReportdataCn ====================",
      this.originalReportdataCn
    );
    for (const original of this.originalReportdataCn) {
      for (const data of original.data) {
        for (const ticket of data.ticket) {
          console.log("======== for of ticket ========");
          databody.push([
            {
              text: (last_index += 1),
              alignment: "center",
              fontSize: 11,
            },
            // {
            //   text: original.bu,
            //   alignment: "center",
            //   fontSize: 11,
            // },
            {
              text: data.branchName,
              alignment: "center",
              fontSize: 11,
            },
            {
              text: this.totalVat.reportheader.returndate,
              alignment: "center",
              fontSize: 11,
            },
            {
              text: ticket.receiptNo,
              alignment: "center",
              fontSize: 11,
            },
            {
              text: ticket.refReceiptNo,
              alignment: "center",
              fontSize: 11,
            },
            {
              text: ticket.totalSaleAmt.replace(
                /(\d)(?=(\d{3})+(?!\d))/g,
                "$1,"
              ),
              alignment: "right",
              fontSize: 11,
            },
            {
              text: ticket.totalNonVatItemAmt.replace(
                /(\d)(?=(\d{3})+(?!\d))/g,
                "$1,"
              ),
              alignment: "right",
              fontSize: 11,
            },
            {
              text: ticket.totalVatItemAmt.replace(
                /(\d)(?=(\d{3})+(?!\d))/g,
                "$1,"
              ),
              alignment: "right",
              fontSize: 11,
            },
            {
              text: ticket.taxValue.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"),
              alignment: "right",
              fontSize: 11,
            },
          ]);
        }
        databody.push([
          {
            text: `ยอดรวมทั้งหมด (${data.branchName})`,
            colSpan: 5,
            alignment: "right",
            bold: true,
            fillColor: "#e0e0e0",
          },

          // "",
          "",
          "",
          "",
          "",
          {
            text: data.loc_totalSaleAmt.replace(
              /(\d)(?=(\d{3})+(?!\d))/g,
              "$1,"
            ),
            bold: true,
            alignment: "right",
            fontSize: 11,
            noWrap: true,
            fillColor: "#e0e0e0",
          },
          {
            text: data.loc_totalNonVatItemAmt.replace(
              /(\d)(?=(\d{3})+(?!\d))/g,
              "$1,"
            ),
            bold: true,
            alignment: "right",
            fontSize: 11,
            noWrap: true,
            fillColor: "#e0e0e0",
          },
          {
            text: data.loc_totalVatItemAmt.replace(
              /(\d)(?=(\d{3})+(?!\d))/g,
              "$1,"
            ),
            bold: true,
            alignment: "right",
            fontSize: 11,
            noWrap: true,
            fillColor: "#e0e0e0",
          },
          {
            text: data.loc_taxValue.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"),
            bold: true,
            noWrap: true,
            alignment: "right",
            fontSize: 11,
            fillColor: "#e0e0e0",
          },
        ]);
      }
    }
    datafooter.push([
      {
        text: "ยอดรวมทั้งหมด",
        alignment: "right",
        colSpan: 5,
        bold: true,
      },
      // "",
      "",
      "",
      "",
      "",
      {
        text: this.totalVat.all_totalSaleAmt.replace(
          /(\d)(?=(\d{3})+(?!\d))/g,
          "$1,"
        ),
        bold: true,
        alignment: "right",
      },
      {
        text: this.totalVat.all_totalNonVatItemAmt.replace(
          /(\d)(?=(\d{3})+(?!\d))/g,
          "$1,"
        ),
        alignment: "right",
        bold: true,
      },
      {
        text: this.totalVat.all_totalVatSaleAmt.replace(
          /(\d)(?=(\d{3})+(?!\d))/g,
          "$1,"
        ),
        alignment: "right",
        bold: true,
      },
      {
        text: this.totalVat.all_taxValue.replace(
          /(\d)(?=(\d{3})+(?!\d))/g,
          "$1,"
        ),
        alignment: "right",
        bold: true,
      },
    ]);

    console.log("======== data body pdf cns =======", JSON.stringify(databody));

    let tel: any;
    let seller_tel: any;
    if (dataAddr.seller_tel !== "") {
      seller_tel = dataAddr.seller_tel
        .substring(1, dataAddr.seller_tel.length)
        .split("+")
        .join(",");
    } else {
      seller_tel = "";
    }
    const content = [
      {
        style: "tableExample",
        table: {
          dontBreakRows: true,
          // border: [true, true, true, true],
          headerRows: 2,
          widths: [20, 100, 80, 90, 100, 80, 80, 80, 70],
          body: [
            [
              {
                colSpan: 9,
                border: [false, false, false, false],
                columns: [
                  {
                    width: 200,
                    text: "",
                  },
                  [
                    {
                      text: `${
                        dataAddr.seller_name +
                        " " +
                        `สาขา${
                          dataAddr.seller_branch == "00000"
                            ? "สำนักงานใหญ่"
                            : dataAddr.seller_branch_name
                        }` +
                        " สาขาที่ " +
                        " " +
                        dataAddr.seller_branch
                      }`,
                      alignment: "center",
                      fontSize: 13,
                    },
                    {
                      text: dataAddr.seller_addrdisplay,
                      width: 500,
                      alignment: "center",
                      fontSize: 13,
                    },
                    {
                      text: `${
                        "โทร. " +
                        seller_tel +
                        " " +
                        "โทรสาร " +
                        dataAddr.seller_fax
                      }`,
                      alignment: "center",
                      fontSize: 13,
                    },
                    {
                      text: `${
                        "เลขที่ประจำตัวผู้เสียภาษี " + dataAddr.seller_taxid
                      }`,
                      alignment: "center",
                      fontSize: 13,
                    },
                    {
                      text: "รายงานสรุปใบลดหนี้คงค้าง",
                      alignment: "center",
                      fontSize: 13,
                      bold: true,
                    },
                    {
                      text: `${
                        "วันที่ " +
                        dataAddr.report_startdate +
                        " - " +
                        dataAddr.report_enddate
                      }`,
                      alignment: "center",
                      fontSize: 13,
                    },
                  ],
                  {
                    width: 200,
                    columns: [
                      [
                        {
                          text: `${
                            "StoreID : " +
                            this.userLoc +
                            " " +
                            dataAddr.seller_name
                          }`,
                          alignment: "right",
                          fontSize: 13,
                          bold: true,
                        },
                        {
                          text: `${"User Login : " + this.userID}`,
                          alignment: "right",
                          fontSize: 12,
                          bold: true,
                        },
                        {
                          text: `${"พิมพ์ : " + this.datapdf}`,
                          alignment: "right",
                          fontSize: 12,
                          bold: true,
                        },
                      ],
                    ],
                  },
                ],
              },
              // "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
            ],
            [
              {
                text: "ลำดับ",
                alignment: "center",
                fontSize: 11,
                fillColor: "#e0e0e0",
                style: "tableHeader",
                bold: true,
              },
              // {
              //   text: "BU",
              //   alignment: "center",
              //   fontSize: 11,
              //   fillColor: "#e0e0e0",
              //   style: "tableHeader",
              //   bold: true,
              // },
              {
                text: "สาขาที่ออกใบกำกับภาษี",
                alignment: "center",
                fontSize: 11,
                fillColor: "#e0e0e0",
                style: "tableHeader",
                bold: true,
              },
              {
                text: "วันที่ออก \nReturn Receipt",
                alignment: "center",
                fontSize: 11,

                fillColor: "#e0e0e0",
                style: "tableHeader",
                bold: true,
              },
              {
                text: "Return Receipt No",
                alignment: "center",
                fontSize: 11,

                fillColor: "#e0e0e0",
                style: "tableHeader",
                bold: true,
              },
              {
                text: "อ้างอิงใบกำกับ\nภาษีอย่างย่อเลขที",
                alignment: "center",
                fontSize: 11,

                fillColor: "#e0e0e0",
                style: "tableHeader",
                bold: true,
              },
              {
                text: "จำนวนเงินรวม",
                alignment: "center",
                fontSize: 11,

                fillColor: "#e0e0e0",
                style: "tableHeader",
                bold: true,
              },
              {
                text: "มูลูค่าสินค้า NON VAT",
                alignment: "center",
                fontSize: 11,

                fillColor: "#e0e0e0",
                style: "tableHeader",
                bold: true,
              },
              {
                text: "มูลค่าสินค้า VAT",
                alignment: "center",
                fontSize: 11,

                fillColor: "#e0e0e0",
                style: "tableHeader",
                bold: true,
              },
              {
                text: "ภาษีมูลค่าเพิ่ม",
                alignment: "center",
                fontSize: 11,

                fillColor: "#e0e0e0",
                style: "tableHeader",
                bold: true,
              },
            ],
            ...databody,
            ...datafooter,
          ],
        },
        layout: {
          hLineWidth: function (i, node) {
            return i === 0 || i === node.table.body.length ? 0.2 : 0.1;
          },
          vLineWidth: function (i, node) {
            return i === 0 || i === node.table.widths.length ? 0.2 : 0.1;
          },
          hLineColor: function (i, node) {
            return i === 0 || i === node.table.body.length
              ? "#424242"
              : "#424242";
          },
          vLineColor: function (i, node) {
            return i === 0 || i === node.table.widths.length
              ? "#424242"
              : "#424242";
          },
        },

        pageBreak: "after",
      },
    ];
    pdfmake.content.push(...content);
    try {
      pdfmake.content[pdfmake.content.length - 1]["pageBreak"] = "";
    } catch (error) {}

    const file_name = `${"REPORT_CN_OUT_" + this.datapdf}`;
    this.downloadPdf(pdfmake, file_name);
  }

  async downloadPdf(dataPDF, file_name) {
    const pdf = pdfMake.createPdf(dataPDF);
    console.log("================downloadPdf=====================");
    try {
      return pdf.download(file_name);
    } catch (error) {
      console.log(error);
      return;
    }
  }
}
